module.exports = __webpack_public_path__ + "static/media/th2_level_1.6dff1db3.png";